import React, { useState, useCallback } from 'react';
import { useRevealChildren } from '../../hooks/useRevealChildren';
import { galleryImages, galleryDescription } from '../../data/galleryData';
import PageHero from '../../components/PageHero/PageHero';
import Footer from '../../components/Footer/Footer';
import './ProjectGallery.css';

function ProjectGallery() {
  const ref = useRevealChildren();
  const [lightbox, setLightbox] = useState(null);

  const openLightbox = useCallback((idx) => setLightbox(idx), []);
  const closeLightbox = useCallback(() => setLightbox(null), []);

  return (
    <>
      <PageHero title="Our Project" subtitle="Project Gallery" />
      <section className="gallery-section" ref={ref}>
        <div className="container">
          <p className="gallery-desc reveal">{galleryDescription}</p>
          <GalleryGrid onOpen={openLightbox} />
        </div>
      </section>
      {lightbox !== null && (
        <Lightbox index={lightbox} onClose={closeLightbox} setIndex={setLightbox} />
      )}
      <Footer />
    </>
  );
}

function GalleryGrid({ onOpen }) {
  return (
    <div className="gallery-grid">
      {galleryImages.map((img, i) => (
        <div
          key={i}
          className={`gallery-item reveal reveal-d${(i % 4) + 1}`}
          onClick={() => onOpen(i)}
        >
          <img src={img.src} alt={img.alt} loading="lazy" />
          <div className="gallery-item-overlay">
            <ZoomIcon />
          </div>
        </div>
      ))}
    </div>
  );
}

function Lightbox({ index, onClose, setIndex }) {
  const img = galleryImages[index];
  const hasPrev = index > 0;
  const hasNext = index < galleryImages.length - 1;

  return (
    <div className="lightbox" onClick={onClose}>
      <button className="lightbox-close" onClick={onClose}>&times;</button>
      <div className="lightbox-inner" onClick={(e) => e.stopPropagation()}>
        {hasPrev && (
          <button className="lightbox-nav prev" onClick={() => setIndex(index - 1)}>&#8249;</button>
        )}
        <img src={img.src} alt={img.alt} />
        {hasNext && (
          <button className="lightbox-nav next" onClick={() => setIndex(index + 1)}>&#8250;</button>
        )}
      </div>
    </div>
  );
}

function ZoomIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="24" height="24">
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
      <line x1="11" y1="8" x2="11" y2="14" />
      <line x1="8" y1="11" x2="14" y2="11" />
    </svg>
  );
}

export default ProjectGallery;
